import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { DsAuthJWTToken } from '@direction/auth';
import { DsSharedLazyModule } from '@direction/translate';
import { FooterComponent } from './components/footer/footer.component';
import { MenuComponent } from './components/menu/menu.component';
import { UserDetailComponent } from './components/menu/user-detail/user-detail.component';
import { NavComponent } from './components/nav/nav.component';

@NgModule({
  declarations: [NavComponent, MenuComponent, FooterComponent, UserDetailComponent],
  imports: [CommonModule, RouterModule, DsSharedLazyModule, MatInputModule, MatIconModule],
  exports: [MenuComponent, FooterComponent],
  providers: [{ provide: DsAuthJWTToken, useClass: DsAuthJWTToken, multi: true }]
})
export class CoreModule {}
